import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import {
  Form,
  InputGroup,
  Modal,
  Row,
  Col,
  CloseButton,
} from "react-bootstrap";
import * as yup from "yup";
import { getCarrierData } from "../../../api/User/Hub/medicalcredentialsApi";
import Fontstyling from "../../../components/common/comman";
import {
  GetClientsMedicalPlanDetails,
  GetClientsMedicalPlanDetailsByID,
  GetClientsMedicalPlanFundingType,
  GetClientsMedicalPlanStopLossInsurer,
  GetClientsMedicalPlanType,
  GetFeeByFundingArrangement,
  GetFeeType,
  getFundingTypeData,
  GetSubFeeByMainFee,
  SaveClientsMedicalPlanDetails,
} from "../../../api/User/Hub/medicalplanApi";
import AddIcon from "../../../assets/icon/circle-plus-solid.svg";
import ReactTooltip from "react-tooltip";
import Required from "../../Required";
import FeesBadge from "../Hub/feesBadge";
import { useSelector } from "react-redux";
import moment from "moment";

let schema = {
  Carrier: yup
    .string()
    .notOneOf(["Select Carrier"], "Please select carrier")
    .required("Please select carrier"),
  FundingArrangement: yup
    .string()
    .notOneOf(
      ["Select Funding Arrangement"],
      "Please select Funding Arrangement"
    )
    .required("Please select Funding Arrangement"),
  StopLossCarrierorInsurer: yup
    .string()
    .notOneOf(["Select Stop Loss"], "Please select stop loss")
    .required("Please select stop loss"),
  ContractStart: yup.date().required("Please select contract start date"),
  ContractEnd: yup.date().required("Please select contract end date"),
  // StopLossContractStart: yup.date().required("required"),
  // StopLossContractEnd: yup.date().required("required"),
  ISLPP: yup.number().required("Please enter ISLPP"),
  PlanName: yup.string().required("Please enter plan name"),
  PlanType: yup.string().required("Please enter plan type"),
  AV: yup.string().required("Please enter AV"),
  TierType: yup.string().required("Please enter tier type"),
};

const MedicalPlanModal = ({
  show,
  onHide,
  witchAction,
  selectedCarrier,
  setResponseMessage,
  deleteMedicalCarrier,
  getData,
}) => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [CarrierData, setCarrierData] = useState([]);
  const [FundingTypes, setFundingTypes] = useState([]);
  const [isFeesSection, setIsFeesSection] = useState(false);
  const buttonRef = useRef(null);
  const [stoploseData, setStoploseData] = useState([]);
  const [length20Error, setLength20Error] = useState({});
  const [FeeTypeError, setFeeTypeError] = useState(false);
  const [feesArrays, setFeesArrays] = useState({});
  const [feeByFundingArrangement, setFeeByFundingArrangement] = useState([]);
  const [updateData, setUpdateDate] = useState(null);
  const [feeTypeRes, setFeeTypeRes] = useState([]);
  const [prevFundFees, setPrevFundFees] = useState([]);
  const [feeListByFundingArrangement, setFeeListByFundingArrangement] =
    useState([]);
  useEffect(() => {
    Promise.all([
      getCarrierData(),
      GetClientsMedicalPlanFundingType(),
      GetClientsMedicalPlanStopLossInsurer(),
      GetFeeType(),
    ]).then(([carrierRes, fundingRes, stopLossRes, feesType]) => {
      const sortedCarrierData = carrierRes.data.sort((a, b) =>
        a.CarrierName.localeCompare(b.CarrierName)
      );
      const sortedFundingTypes = fundingRes.data.sort((a, b) =>
        a.MedFundName.localeCompare(b.MedFundName)
      );
      const sortedStopLossData = stopLossRes.data.sort((a, b) =>
        a.StopLossName.localeCompare(b.StopLossName)
      );

      setCarrierData(sortedCarrierData);
      setFundingTypes(sortedFundingTypes);
      setStoploseData(sortedStopLossData);
      setFeeTypeRes(feesType.data);
    });
    if (witchAction === "update") {
      getMedicalPlanDetails();
    }
  }, []);

  useEffect(() => {
    if (!show) {
      setIsFeesSection(false);
      setFeesArrays({});
      setLength20Error({});
    }
  }, [show]);

  const getMedicalPlanDetails = () => {
    GetClientsMedicalPlanDetailsByID(
      client?.clientID,
      user?.UD_id,
      selectedCarrier.CMedicalPlanID
    )
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setUpdateDate(res.data[0]);
          let prevFees = null;
          if (
            !(
              res.data[0]?.cMedicalPlanFees === null ||
              res.data[0]?.cMedicalPlanFees[0]?.cMedicalPlanMainFees[0]
                ?.cMedicalPlanSubFees.length === 0
            )
          ) {
            prevFees =
              res.data[0]?.cMedicalPlanFees[0]?.cMedicalPlanMainFees?.reduce(
                (result, f) => ({
                  ...result,
                  [f.feeName.replace(/\s/g, "")]: f.cMedicalPlanSubFees,
                }),
                {}
              );
          }
          setPrevFundFees(prevFees);

          let val = {
            MedFundTypeID: res.data[0]?.cMedicalPlanFundingID,
            MedFundName: selectedCarrier?.FundingName,
          };

          handleChangeFundingArrangement(val, prevFees);
        }
      })
      .catch((err) => console.log(err));
  };

  const handelSubmit = async (e, bag) => {
    let ContractStart = new Date(e.ContractStart).toISOString();
    let ContractEnd = new Date(e.ContractEnd).toISOString();
    let StopLossContractStart =
      e.StopLossContractStart !== ""
        ? new Date(e.StopLossContractStart).toISOString()
        : null;
    let StopLossContractEnd =
      e.StopLossContractEnd !== ""
        ? new Date(e.StopLossContractEnd).toISOString()
        : null;
    let carrierData = JSON.parse(e.Carrier);
    let fundArrangeData = JSON.parse(e.FundingArrangement);
    let StopLoass = JSON.parse(e.StopLossCarrierorInsurer);
    let CMedicalPlanMainFees = [];
    for (let key in feesArrays) {
      if (feesArrays[key].length) {
        CMedicalPlanMainFees.push({
          FeeID: feeListByFundingArrangement?.find(
            (el) => el.FeeName.replace(/\s/g, "") === key
          ).FeeID,
          feeName: feeListByFundingArrangement?.find(
            (el) => el.FeeName.replace(/\s/g, "") === key
          ).FeeName,
          cMedicalPlanSubFees: feesArrays[key].map((el) => ({
            subFeeID: el.subFeeID,
            subFeeName:
              el.subFeeName === "Create new fee"
                ? el.subFeeNameAlias
                : el.subFeeName,
            subFeeNameAlias:
              el.subFeeName === "Create new fee"
                ? ""
                : el.subFeeNameAlias
                ? el.subFeeNameAlias
                : "",
            feeTypeID: el.feeTypeID,
            feeTypeName: el.feeTypeName,
            feeTypeNameAlias: el.feeTypeNameAlias,
            amount: +el.amount,
            // ...el.budgetedMonth &&{ budgetedMonth: el.budgetedMonth},
            budgetedMonth: el.budgetedMonth?? null,
            isfeeUserDefine: el.isfeeUserDefine,
          })),
        });
      }
    }
    let payload = {
      cMedicalPlanID:
        witchAction === "add" ? 0 : selectedCarrier.CMedicalPlanID,
      cMedicalPlanClientID: client?.clientID,
      cMedicalPlanUserID: user?.UD_id,
      cMedicalPlanRegionID: client?.regionId,
      cMedicalPlanCarrierID: carrierData.CarrierID,
      cMedicalPlanContractStart: ContractStart,
      cMedicalPlanContractEnd: ContractEnd,
      cMedicalPlanFundingID: +fundArrangeData.MedFundTypeID,
      cMedicalPlanStopLoassID: +StopLoass.StopLossID,
      cMedicalPlanStopLossCarrierContractStart: StopLossContractStart,
      cMedicalPlanStopLossCarrierContractEnd: StopLossContractEnd,
      cMedicalPlanISL_PP: +e.ISLPP,
      cMedicalPlanName: e.PlanName,
      cMedicalPlanType: e.PlanType,
      cMedicalPlanAV: e.AV,
      cMedicalPlanTierType: e.TierType,
      cMedicalPlanFees: [
        {
          cMedicalPlanID:
            witchAction === "add" ? 0 : selectedCarrier.CMedicalPlanID,
          clientID: client?.clientID,
          clientName: client?.clientName,
          categoryName: "Medical",
          medFundName: fundArrangeData.MedFundName,
          carrierName: carrierData.CarrierName,
          cMedicalPlanMainFees: CMedicalPlanMainFees,
        },
      ],
      cMedicalPlanCreatedBy: user?.UD_id,
    };

    await SaveClientsMedicalPlanDetails(JSON.stringify(payload)).then((res) => {
      if (res.status === 200) {
        if (res.data === "Requested region is rejected") {
          setResponseMessage("rejectedRegion");
        } else {
          setResponseMessage(res.data);
          getData();
        }
      } else {
        setResponseMessage("error");
      }
      bag.setValues({
        Carrier: "",
        ContractStart: "",
        ContractEnd: "",
        FundingArrangement: "",
        StopLossCarrierorInsurer: "",
        StopContractStart: "",
        StopContractEnd: "",
        ISLPP: "",
        PlanName: "",
        PlanType: "",
        AV: "",
        TierType: "",
      });
    });
    onHide();
  };

  const handleAddFees = (values, handlres, witchFees) => {
    if (
      (witchFees === "StopLossFee" &&
        feesArrays[witchFees].filter(
          (item) => item.subFeeName === values.subFeeName
        ).length === 20) ||
      (witchFees !== "StopLossFee" &&
        values.isfeeUserDefine &&
        feesArrays[witchFees].filter((item) => item.isfeeUserDefine === 1)
          .length === 20)
    ) {
      setLength20Error((prev) => ({ ...prev, [witchFees]: true }));
    } else if (
      values.subFeeName === "Create new fee" &&
      values.subFeeNameAlias === ""
    ) {
      return;
    } else if (
      !values.isfeeUserDefine &&
      feesArrays[witchFees].some(
        (v) =>
          !v.isfeeUserDefine &&
          v.subFeeName === values.subFeeName &&
          v.feeTypeName === values.feeTypeName
      )
    ) {
      setFeeTypeError(true);
    } else {
      let feeTypeID = feeTypeRes?.find(
        (el) => el.FeeTypeName === values.feeTypeName
      )?.FeeTypeID;

      const id =
        parseInt(new Date().toISOString().replace(/[-:.TZ]/g, "")) % 100000000;
      setFeesArrays((prev) => ({
        ...prev,
        [witchFees]: [
          ...prev[witchFees],
          { ...values, feeTypeID, subFeeID: id },
        ],
      }));
    }
    handlres.resetForm();
  };

  const handleChangeFundingArrangement = async (val, prevFees) => {
    // const value = +e.target.value;
    let { MedFundTypeID } = val;
    if (MedFundTypeID !== 2) {
      schema.StopLossContractStart = yup
        .date()
        .required("Please select SL contract start date");
      schema.StopLossContractEnd = yup
        .date()
        .required("Please select SL contract end date");
    } else {
      schema.StopLossContractStart = null;
      schema.StopLossContractEnd = null;
    }
    try {
      setIsFeesSection(false);
      const res = await GetFeeByFundingArrangement(1, MedFundTypeID);
      setFeeListByFundingArrangement(res.data);
      if (res.data.length) {
        const length20 = res.data.reduce((acc, obj) => {
          acc[obj.FeeName.replace(/\s/g, "")] = false;
          return acc;
        }, {});
        const transformedObj = res.data.reduce((acc, obj) => {
          acc[obj.FeeName.replace(/\s/g, "")] = [];
          return acc;
        }, {});
        setLength20Error(length20);
        if (prevFees) {
          setFeesArrays({ ...transformedObj, ...prevFees });
        } else {
          setFeesArrays(transformedObj);
        }
        let updatedData = [];
        updatedData = await Promise.all(
          res.data.map(async (item) => {
            const subRes = await GetSubFeeByMainFee(
              1,
              item.FundingID,
              item.FeeID
            );
            const subFeeData = subRes.data.length ? subRes.data : [];

            return { ...item, subFee: subFeeData };
          })
        );

        setFeeByFundingArrangement(updatedData);
        setIsFeesSection(true);
      } else {
        setIsFeesSection(false);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={Fontstyling.modalHeading}
        >
          {witchAction === "add"
            ? "Add New "
            : witchAction === "update"
            ? "Update "
            : "Delete "}
          Plan
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="overflow-auto d-flex flex-column"
        style={{ maxHeight: "60vh" }}
      >
        <Formik
          enableReinitialize
          validationSchema={
            witchAction !== "delete" && yup.object().shape(schema)
          }
          onSubmit={handelSubmit}
          initialValues={{
            Carrier:
              selectedCarrier.Carrier && selectedCarrier.CMedicalPlanCarrierID
                ? JSON.stringify({
                    CarrierID: selectedCarrier.CMedicalPlanCarrierID,
                    CarrierName: selectedCarrier.Carrier,
                  })
                : "Select Carrier",
            ContractStart:
              updateData && updateData.cMedicalPlanContractStart
                ? updateData.cMedicalPlanContractStart.split("T")[0]
                : "",
            ContractEnd:
              updateData && updateData.cMedicalPlanContractEnd
                ? updateData.cMedicalPlanContractEnd.split("T")[0]
                : "",
            FundingArrangement:
              selectedCarrier.FundingName &&
              selectedCarrier.CMedicalPlanFundingID
                ? JSON.stringify({
                    MedFundTypeID: selectedCarrier.CMedicalPlanFundingID,
                    MedFundName: selectedCarrier.FundingName,
                  })
                : "Select Funding Arrangement",
            StopLossCarrierorInsurer:
              selectedCarrier.StopLossName &&
              selectedCarrier.CMedicalPlanStopLoassID
                ? JSON.stringify({
                    StopLossID: selectedCarrier.CMedicalPlanStopLoassID,
                    StopLossName: selectedCarrier.StopLossName,
                  })
                : "Select Stop Loss",
            StopLossContractStart:
              updateData && updateData.cMedicalPlanStopLossCarrierContractStart
                ? updateData.cMedicalPlanStopLossCarrierContractStart.split(
                    "T"
                  )[0]
                : //: moment(new Date()).format("yyyy-MM-DD"),
                  "",
            StopLossContractEnd:
              updateData && updateData.cMedicalPlanStopLossCarrierContractEnd
                ? updateData.cMedicalPlanStopLossCarrierContractEnd.split(
                    "T"
                  )[0]
                : // : moment(new Date()).format("yyyy-MM-DD"),
                  "",
            ISLPP: updateData?.cMedicalPlanISL_PP
              ? updateData.cMedicalPlanISL_PP
              : 0,
            PlanName: updateData?.cMedicalPlanName
              ? updateData.cMedicalPlanName
              : "",
            PlanType: updateData ? updateData.cMedicalPlanType : "",
            AV: updateData ? updateData.cMedicalPlanAV : "",
            TierType: updateData ? updateData.cMedicalPlanTierType : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} id="form1">
              <Row className="mb-3 justify-content-between">
                <Form.Group as={Col} xs={6} lg className=" px-2">
                  <Form.Label style={Fontstyling.label}>
                    Carrier <Required />
                  </Form.Label>
                  <Form.Select
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    name="Carrier"
                    value={values.Carrier}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={witchAction === "update"}
                    isInvalid={
                      values.Carrier === "Select Carrier" && touched.Carrier
                    }
                  >
                    <option value={"Select Carrier"}>Select Carrier</option>
                    {CarrierData.map((item, index) => (
                      <option key={index} value={JSON.stringify(item)}>
                        {item.CarrierName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.Carrier}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  as={Col}
                  xs={6}
                  lg
                  className=" px-2"
                  controlId="validationFormik02"
                >
                  <Form.Label style={Fontstyling.label}>
                    Contract Start <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                    type="date"
                    name="ContractStart"
                    placeholder="Authorized User"
                    value={values.ContractStart}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={errors.ContractStart && touched.ContractStart}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ContractStart}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  as={Col}
                  xs={6}
                  lg
                  className=" px-2"
                  controlId="validationFormik03"
                >
                  <Form.Label style={Fontstyling.label}>
                    Contract End <Required />
                  </Form.Label>
                  {witchAction === "add" && (
                    <>
                      <img
                        data-tip="Select start date first"
                        src={require("../../../assets/icon/Question_mark_back.png")}
                        style={{ height: 12, marginLeft: 3 }}
                      />
                      <ReactTooltip />
                    </>
                  )}
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                    type="date"
                    name="ContractEnd"
                    value={values.ContractEnd}
                    min={values.ContractStart}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={values.ContractStart ? false : true}
                    isInvalid={errors.ContractEnd && touched.ContractEnd}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ContractEnd}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  as={Col}
                  xs={6}
                  lg
                  className=" px-2"
                  controlId="validationFormik04"
                >
                  <Form.Label style={Fontstyling.label}>
                    Funding Arrangement <Required />
                  </Form.Label>
                  <Form.Select
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    name="FundingArrangement"
                    onChange={(e) => {
                      handleChange(e);
                      let val = JSON.parse(e?.target?.value);
                      if (
                        val?.MedFundTypeID ===
                        selectedCarrier.CMedicalPlanFundingID
                      ) {
                        handleChangeFundingArrangement(val, prevFundFees);
                      } else {
                        handleChangeFundingArrangement(val);
                      }
                    }}
                    onBlur={handleBlur}
                    disabled={witchAction === "delete"}
                    value={values.FundingArrangement}
                    isInvalid={
                      values.FundingArrangement ===
                        "Select Funding Arrangement" &&
                      touched.FundingArrangement
                    }
                  >
                    <option value={"Select Funding Arrangement"}>
                      Select Funding Arrangement
                    </option>
                    {FundingTypes.map((item, index) => (
                      <option value={JSON.stringify(item)} key={index}>
                        {item.MedFundName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.FundingArrangement}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group
                  className="px-1"
                  as={Col}
                  xs={6}
                  md={4}
                  controlId="validationFormik004"
                >
                  <Form.Label style={Fontstyling.label}>
                    Stop Loss Carrier Or Insurer
                  </Form.Label>
                  <Form.Select
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    name="StopLossCarrierorInsurer"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={witchAction === "delete"}
                    value={values.StopLossCarrierorInsurer}
                    isInvalid={
                      values.StopLossCarrierorInsurer === "Select Stop Loss" &&
                      touched.StopLossCarrierorInsurer
                    }
                  >
                    <option value={"Select Stop Loss"}>
                      Select Stop Loss <Required />
                    </option>

                    {stoploseData.map((item, index) => (
                      <option value={JSON.stringify(item)} key={index}>
                        {item.StopLossName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.StopLossCarrierorInsurer}
                  </Form.Control.Feedback>
                </Form.Group>
                {values?.FundingArrangement !== "Select Funding Arrangement" &&
                  JSON.parse(values?.FundingArrangement).MedFundTypeID !==
                    2 && (
                    <>
                      <Form.Group
                        as={Col}
                        controlId="validationFormik02"
                        className="px-1"
                        xs={6}
                        md={4}
                      >
                        <Form.Label style={Fontstyling.label}>
                          Stop Loss Carrier Contract Start <Required />
                        </Form.Label>
                        <Form.Control
                          className="rounded-0 py-1"
                          style={{
                            ...Fontstyling.label,
                            textTransform: "uppercase",
                          }}
                          type="date"
                          name="StopLossContractStart"
                          value={values.StopLossContractStart}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            errors.StopLossContractStart &&
                            touched.StopLossContractStart
                          }
                          // disabled={
                          //   values?.FundingArrangement !==
                          //   "Select Funding Arrangement"
                          //     ? JSON.parse(values?.FundingArrangement)
                          //         .MedFundTypeID === 2
                          //     : false
                          // }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.StopLossContractStart}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} controlId="validationFormik03">
                        <Form.Label style={Fontstyling.label}>
                          Stop Loss Carrier Contract End <Required />
                        </Form.Label>
                        {witchAction === "add" && (
                          <>
                            <img
                              data-tip="Select start date first"
                              src={require("../../../assets/icon/Question_mark_back.png")}
                              style={{ height: 12, marginLeft: 3 }}
                            />
                            <ReactTooltip />
                          </>
                        )}
                        <Form.Control
                          className="rounded-0 py-1"
                          style={{
                            ...Fontstyling.label,
                            textTransform: "uppercase",
                          }}
                          type="date"
                          name="StopLossContractEnd"
                          value={values.StopLossContractEnd}
                          min={values.StopLossContractStart}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={values.StopLossContractStart ? false : true}
                          isInvalid={
                            errors.StopLossContractEnd &&
                            touched.StopLossContractEnd
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.StopLossContractEnd}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </>
                  )}
                <Form.Group
                  as={Col}
                  className="px-1"
                  xs={6}
                  sm={6}
                  md={4}
                  controlId="validationFormik05"
                >
                  <Form.Label style={Fontstyling.label}>
                    ISL / PP <Required />
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text className="py-0 fw-bold">
                      $
                    </InputGroup.Text>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="number"
                      name="ISLPP"
                      value={values.ISLPP}
                      onChange={handleChange}
                      isInvalid={errors.ISLPP && touched.ISLPP}
                      disabled={witchAction === "delete"}
                    />
                  </InputGroup>
                  {touched.ISLPP && errors.ISLPP && (
                    <div className="text-danger pt-2" style={Fontstyling.label}>
                      {errors.ISLPP}
                    </div>
                  )}
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group
                  as={Col}
                  xs={6}
                  className="px-1"
                  md={4}
                  controlId="validationFormik06"
                >
                  <Form.Label style={Fontstyling.label}>
                    Plan Name <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    type="text"
                    placeholder="Plan Name"
                    name="PlanName"
                    value={values.PlanName}
                    onChange={handleChange}
                    isInvalid={touched.PlanName && errors.PlanName}
                    disabled={witchAction === "delete"}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.PlanName}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  xs={6}
                  className="px-1"
                  md={4}
                  controlId="validationFormik07"
                >
                  <Form.Label style={Fontstyling.label}>
                    Plan Type <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label }}
                    type="text"
                    name="PlanType"
                    value={values.PlanType}
                    placeholder="Plan Type"
                    onChange={handleChange}
                    isInvalid={touched.PlanType && errors.PlanType}
                    disabled={witchAction === "delete"}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.PlanType}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  xs={6}
                  className="px-1"
                  md={4}
                  controlId="validationFormik08"
                >
                  <Form.Label style={Fontstyling.label}>
                    AV <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label }}
                    type="number"
                    name="AV"
                    step={0.1}
                    placeholder="0.1"
                    value={values.AV}
                    onChange={handleChange}
                    isInvalid={touched.AV && errors.AV}
                    disabled={witchAction === "delete"}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.AV}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  as={Col}
                  xs={6}
                  className="px-1"
                  md={4}
                  controlId="validationFormik09"
                >
                  <Form.Label style={Fontstyling.label}>
                    Tier Type <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label }}
                    type="text"
                    name="TierType"
                    value={values.TierType}
                    placeholder="Tier Type"
                    onChange={handleChange}
                    isInvalid={touched.TierType && errors.TierType}
                    disabled={witchAction === "delete"}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.TierType}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
            </Form>
          )}
        </Formik>
        {isFeesSection &&
          feeByFundingArrangement.map((value) => {
            let witchFees = value.FeeName.replace(/\s/g, "");
            let initialValues = {
              isfeeUserDefine: 0,
              subFeeName: "",
              subFeeNameAlias: "",
              feeTypeName: "Select Fees Type",
              feeTypeNameAlias: "",
              amount: "",
            };

            let feesSchema = {
              subFeeName: yup.string().required("Please enter sub fee name"),
              feeTypeName: yup
                .string()
                .notOneOf(["Select Fees Type"], "Please select fee type")
                .required("Please select fee type"),
              amount: yup
                .number()
                .typeError("Enter number")
                .required("Please enter amount"),
            };
            let subFeeOption = [];

            if (value.subFee.length) {
              initialValues.subFeeNameAlias = "";
              if (witchFees === "StopLossFee") {
                feesSchema.subFeeNameAlias = yup
                  .string()
                  .required("Please enter fee alias");
                subFeeOption = value?.subFee;
              } else {
                subFeeOption = [
                  ...value?.subFee,
                  {
                    FundingID: value.subFee[0].FundingID,
                    FeeID: value.subFee[0].FeeID,
                    FeeName: value.subFee[0].FeeName,
                    SubFeeID: 0,
                    SubFeeName: "Create new fee",
                    style: 1,
                  },
                ];
              }
            } else if (witchFees === "BudgetedRates") {
              initialValues.budgetedMonth = moment().startOf('month').format('YYYY-MM-DD');
              feesSchema.budgetedMonth = yup
                .date().max('12-31-9999','Please enter valid date')
                .required("Please enter date");
            }

            return (
              <div className="border-top">
                <div style={Fontstyling.heading} className="my-3">
                  {value.FeeName}
                </div>
                <Formik
                  validationSchema={yup.object().shape(feesSchema)}
                  onSubmit={(values, handlers) =>
                    handleAddFees(values, handlers, witchFees)
                  }
                  //</div>}
                  initialValues={initialValues}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    values,
                    touched,
                    errors,
                  }) => (
                    <Form onSubmit={handleSubmit} name="medicalClaims">
                      <Row className="mb-3 justify-content-start">
                        {value.subFee.length ? (
                          <>
                            <Col className="px-1 my-2" xs={6} lg>
                              <Form.Group className="text-start">
                                <Form.Select
                                  className="rounded-0 py-1"
                                  style={Fontstyling.label}
                                  name="subFeeName"
                                  value={values.subFeeName}
                                  onChange={(e) => {
                                    e.target.value === "Create new fee"
                                      ? setFieldValue("isfeeUserDefine", 1)
                                      : setFieldValue("isfeeUserDefine", 0);
                                    handleChange(e);
                                    setFeeTypeError(false);
                                    setLength20Error((prev) => ({
                                      ...prev,
                                      [witchFees]: false,
                                    }));
                                  }}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    errors.subFeeName && touched.subFeeName
                                  }
                                >
                                  <option value={""}>Select Fees</option>
                                  {subFeeOption.map((item, index) => (
                                    <option
                                      key={index}
                                      value={item.SubFeeName}
                                      style={{
                                        color: item?.style === 1 && "blue",
                                      }}
                                    >
                                      {item.SubFeeName}
                                    </option>
                                  ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                  {errors.subFeeName}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            {(witchFees === "StopLossFee" ||
                              values.subFeeName === "Create new fee") && (
                              <Col className="px-1 my-2" xs={6} lg>
                                <Form.Group className="text-start">
                                  <Form.Control
                                    name="subFeeNameAlias"
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    value={values.subFeeNameAlias}
                                    maxLength={25}
                                    onChange={(e) => {
                                      setFieldValue("isfeeUserDefine", 1);
                                      handleChange(e);
                                    }}
                                    onBlur={handleBlur}
                                    isInvalid={
                                      touched.subFeeNameAlias &&
                                      values.subFeeNameAlias === ""
                                    }
                                    type="text"
                                    placeholder="Fees name"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter fees name
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            )}
                          </>
                        ) : (
                          <Col className="px-1 my-2" xs={6} lg>
                            <Form.Group className="text-start">
                              <Form.Control
                                name="subFeeName"
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                value={values.subFeeName}
                                maxLength={25}
                                onChange={(e) => {
                                  setFieldValue("isfeeUserDefine", 1);
                                  handleChange(e);
                                  setFeeTypeError(false);
                                }}
                                onBlur={handleBlur}
                                isInvalid={
                                  touched.subFeeName && errors.subFeeName
                                }
                                type="text"
                                placeholder="Fees name"
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.subFeeName}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        )}

                        <Col className="px-1 my-2" xs={6} lg>
                          <Form.Group className="text-start">
                            <Form.Select
                              className="rounded-0 py-1"
                              style={Fontstyling.label}
                              name="feeTypeName"
                              value={values.feeTypeName}
                              onChange={(e) => {
                                handleChange(e);
                                setFeeTypeError(false);
                              }}
                              onBlur={handleBlur}
                              isInvalid={
                                values.feeTypeName === "Select Fees Type" &&
                                touched.feeTypeName
                              }
                            >
                              <option value={"Select Fees Type"}>
                                Select Fees Type
                              </option>
                              {value.FeeID < 4
                                ? feeTypeRes
                                    ?.filter((obj) => obj.FeeTypeGroup === 1)
                                    .map((item, index) => (
                                      <option
                                        key={index}
                                        value={item.FeeTypeName}
                                      >
                                        {item.FeeTypeName}
                                      </option>
                                    ))
                                : feeTypeRes?.map((item, index) => (
                                    <option
                                      key={index}
                                      value={item.FeeTypeName}
                                    >
                                      {item.FeeTypeName}
                                    </option>
                                  ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.feeTypeName}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col className="px-1 my-2" xs={6} lg>
                          <Form.Group className="text-start">
                            <Form.Control
                              name="feeTypeNameAlias"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.feeTypeNameAlias}
                              onChange={handleChange}
                              maxLength={25}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.feeTypeNameAlias &&
                                errors.feeTypeNameAlias
                              }
                              type="text"
                              placeholder="Fees Type Alias"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.feeTypeNameAlias}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col className="px-1 my-2" xs={6} lg>
                          <Form.Group className="text-start">
                            <InputGroup>
                              <InputGroup.Text className="py-0 fw-bold">
                                $
                              </InputGroup.Text>
                              <Form.Control
                                name="amount"
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                value={values.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={touched.amount && errors.amount}
                                type="text"
                                maxLength={10}
                                placeholder="Amount"
                              />
                            </InputGroup>
                            {touched.amount && errors.amount && (
                              <div
                                className="text-danger pt-2"
                                style={Fontstyling.label}
                              >
                                {errors.amount}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        {witchFees === "BudgetedRates" && (
                          <Col className="px-1 my-2" xs={6} lg>
                            <Form.Group className="text-start">
                              <Form.Control
                                className="rounded-0 py-1"
                                style={{
                                  ...Fontstyling.label,
                                  textTransform: "uppercase",
                                }}
                                type="date"
                                name="budgetedMonth"
                                // placeholder="Authorized User"
                                value={values.budgetedMonth}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={
                                  errors.budgetedMonth && touched.budgetedMonth
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                              {errors.budgetedMonth}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        )}
                        <Col className="mx-2 my-2 d-flex align-items-baseline">
                          <button
                            className="btn p-0 m-0 rounded-circle border-0"
                            type="submit"
                          >
                            <img
                              src={AddIcon}
                              alt="add plus icon"
                              className="cursor-pointer"
                              width={24}
                            />
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
                {length20Error[witchFees] ? (
                  <div className="text-danger" style={Fontstyling.label}>
                    You can't add more than 20 fees
                  </div>
                ) : (witchFees == "AdministrativeFee(ASOFee)" ||
                    witchFees == "AdministrativeFee") &&
                  FeeTypeError ? (
                  <div className="text-danger" style={Fontstyling.label}>
                    Fees type already exists
                  </div>
                ) : null}
                <div className="row">
                  {feesArrays[witchFees]?.map((item, index) => (
                    <FeesBadge
                      item={item}
                      feesArrays={feesArrays}
                      setFeesArrays={setFeesArrays}
                      key={index}
                      witchFees={witchFees}
                      setLength20Error={setLength20Error}
                    />
                  ))}
                </div>
              </div>
            );
          })}
      </Modal.Body>
      <Modal.Footer>
        {" "}
        <div className="d-flex align-items-center justify-content-end gap-3">
          <button
            ref={buttonRef}
            style={Fontstyling.savebutton}
            type="submit"
            form="form1"
          >
            save
          </button>
          <button
            style={Fontstyling.cancelbutton}
            type="reset"
            onClick={() => {
              // resetForm();
              onHide();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MedicalPlanModal;
